import axios from "axios";

// export const baseUrl="http://192.168.1.3:6070/";
// export const baseUrl="https://kidsdal.com/";
// export const baseUrl = "http://localhost:6071/";
export const baseUrl = "/";

export const getImagesApi = async () => {
    const response = await axios.get(`${baseUrl}api/v1/get-images`);
    return response;
}

export const getVideosApi = async () => {
    const response = await axios.get(`${baseUrl}api/v1/get-videos`);
    return response;
}

export const getFunFactApi = async () => {
    const response = await axios.get(`${baseUrl}api/v1/fun-fact`);
    return response;
}

export const getContentApi = async () => {
    const response = await axios.get(`${baseUrl}api/v1/get-all-content`);
    return response;
}

export async function getGameData(gid){
  return await axios.get(`${baseUrl}api/v1/get-game-content?gameId=${gid}`);
}
